import { render, staticRenderFns } from "./noneData.vue?vue&type=template&id=5ac09a94&"
import script from "./noneData.vue?vue&type=script&lang=js&"
export * from "./noneData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports